export enum AccountType {
  Approved = 'APPROVED',
  Submitted = 'SUBMITTED',
  NotSubmitted = 'NOT_SUBMITTED',
  OnReview = 'ON_REVIEW',
  NeedRevision = 'NEED_REVISION',
  TemporarilySuspend = 'TEMPORARILY_SUSPEND',
  Resubmitted = 'RESUBMITTED',
  Closed = 'CLOSED',
  Rejected = 'REJECTED',
}
